// HtmlImport — client helper of the imported-HTML widget (Palladium.Client/Components/.../HtmlImport.razor).
// Shipped with the site scripts so the circuit no longer sends this installer (18 KB) over JS interop for EVERY
// imported node after the first render: on a phone that chain delayed every tap by 2–6 s (Babylone, 14/10/2026).
// The component keeps the same code as a fallback (eval) when this file is missing. Idempotent; IIFE (bundled).
(function () {
if (!window.__palladiumHtmlImport) {
    window.__palladiumHtmlImport = {
        bootstrap: function (containerId, html, culture, translations) {
            var c = document.getElementById(containerId);
            if (!c) return;
            if (c.dataset.palladiumHtmlBootstrapped === '1') return;
            c.dataset.palladiumHtmlBootstrapped = '1';

            // Escape <script>/<style> inside <code>/<pre> before innerHTML
            // so the HTML parser doesn't create real script elements
            // (inline <code><script></code> without </script> would eat the rest of the page)
            html = html.replace(/<(code|pre)\b([^>]*)>([\s\S]*?)<\/\1>/gi, function(m, tag, attrs, inner) {
                var esc = inner
                    .replace(/<(\/?)(script|style|iframe|textarea|title|xmp|noembed|noframes|noscript)\b/gi, '&lt;$1$2');
                return '<' + tag + attrs + '>' + esc + '</' + tag + '>';
            });

            c.innerHTML = html;

            var removeImportMarkers = function (root) {
                var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
                var nodes = [];
                while (walker.nextNode()) nodes.push(walker.currentNode);

                nodes.forEach(function (node) {
                    var text = (node.nodeValue || '').replace(/\s+/g, ' ').trim();
                    if (/^={3,}\s*[^=<>]{1,80}\s*={3,}$/.test(text)) {
                        node.remove();
                    }
                });
            };

            var escapeSelectorId = function (id) {
                if (window.CSS && CSS.escape) return CSS.escape(id);
                return id.replace(/([ #;?%&,.+*~\':!^$[\]()=>|\/@])/g, '\\$1');
            };

            removeImportMarkers(c);

            var applyTranslation = function (el, val) {
                if (!el.querySelector('*')) {
                    el.innerHTML = val;
                    return;
                }
                if (val.indexOf('<') >= 0) {
                    var srcLinks = [];
                    el.querySelectorAll('a').forEach(function(a) {
                        srcLinks.push(a.getAttribute('href'));
                    });
                    el.innerHTML = val;
                    el.querySelectorAll('[data-gjs-type]').forEach(function(e) { e.removeAttribute('data-gjs-type'); });
                    el.querySelectorAll('[draggable]').forEach(function(e) { e.removeAttribute('draggable'); });
                    var newLinks = el.querySelectorAll('a');
                    for (var li = 0; li < newLinks.length && li < srcLinks.length; li++) {
                        if (srcLinks[li]) newLinks[li].setAttribute('href', srcLinks[li]);
                    }
                    return;
                }
                var hasIdKids = el.querySelector('[id]') !== null;
                var tw = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
                var textNodes = [];
                var nd;
                while ((nd = tw.nextNode())) {
                    if (nd.textContent.trim().length === 0) continue;
                    if (hasIdKids) {
                        var pp = nd.parentNode; var sk = false;
                        while (pp && pp !== el) {
                            if (pp.nodeType === 1 && pp.id) { sk = true; break; }
                            pp = pp.parentNode;
                        }
                        if (sk) continue;
                    }
                    textNodes.push(nd);
                }
                if (textNodes.length === 0) return;
                if (textNodes.length === 1) {
                    var orig = textNodes[0].textContent;
                    textNodes[0].textContent = orig.match(/^\s*/)[0] + val.trim() + orig.match(/\s*$/)[0];
                    return;
                }
                var words = val.split(/\s+/).filter(function(w) { return w.length > 0; });
                var origWC = textNodes.map(function(tn) {
                    return tn.textContent.trim().split(/\s+/).filter(function(w) { return w.length > 0; }).length;
                });
                var total = origWC.reduce(function(s,c) { return s+c; }, 0);
                if (total === 0) { textNodes[0].textContent = val; for (var j=1;j<textNodes.length;j++) textNodes[j].textContent=''; return; }
                var wIdx = 0;
                for (var i = 0; i < textNodes.length; i++) {
                    var oN = textNodes[i].textContent;
                    var ld = oN.match(/^\s*/)[0]; var tr = oN.match(/\s*$/)[0];
                    if (i === textNodes.length - 1) {
                        var rem = words.slice(wIdx);
                        textNodes[i].textContent = rem.length > 0 ? ld + rem.join(' ') + tr : '';
                    } else {
                        var prop = origWC[i] / total;
                        var cnt = Math.max(1, Math.round(prop * words.length));
                        var maxH = words.length - wIdx - (textNodes.length - i - 1);
                        cnt = Math.min(cnt, Math.max(1, maxH));
                        var seg = words.slice(wIdx, wIdx + cnt);
                        textNodes[i].textContent = seg.length > 0 ? ld + seg.join(' ') + tr : '';
                        wIdx += cnt;
                    }
                }
            };

            if (culture && translations) {
                Object.keys(translations).forEach(function (id) {
                    var values = translations[id];
                    if (!values || !values[culture]) return;

                    var el = c.querySelector('#' + escapeSelectorId(id));
                    if (!el) return;

                    applyTranslation(el, values[culture]);
                });
            }

            // Imported landing pages often rely on their original JS to add
            // animation-ready classes such as `.reveal.in`. Converted sections
            // no longer keep that page script, so force the content visible.
            c.querySelectorAll('.reveal').forEach(function (el) {
                el.classList.add('in');
            });

            c.querySelectorAll('pre script, pre style, pre link, pre meta, pre iframe, pre textarea, pre noscript, code script, code style, code link, code meta, code iframe, code textarea, code noscript').forEach(function (el) {
                var txt = document.createTextNode(el.outerHTML);
                el.parentNode.replaceChild(txt, el);
            });

            var head = document.head;
            var isStylesheetLink = function (el) {
                if (el.tagName !== 'LINK' || !el.getAttribute('href')) return false;
                var rel = (el.getAttribute('rel') || '').toLowerCase().split(/\s+/);
                return rel.indexOf('stylesheet') >= 0 || (rel.indexOf('preload') >= 0 && (el.getAttribute('as') || '').toLowerCase() === 'style');
            };

            // 2. Lift <link rel='stylesheet'> and <style> into <head>.
            c.querySelectorAll('link, style, meta').forEach(function (el) {
                if (isStylesheetLink(el)) {
                    var href = el.getAttribute('href');
                    var sel = 'link[rel=\'stylesheet\'][href=\'' + href.replace(/'/g, "\\\'") + '\']';
                    if (!head.querySelector(sel)) {
                        var clone = document.createElement('link');
                        for (var i = 0; i < el.attributes.length; i++) {
                            var a = el.attributes[i];
                            clone.setAttribute(a.name, a.value);
                        }
                        head.appendChild(clone);
                    }
                    el.remove();
                } else if (el.tagName === 'STYLE') {
                    var s = document.createElement('style');
                    s.textContent = el.textContent;
                    head.appendChild(s);
                    el.remove();
                } else if (el.tagName === 'META') {
                    el.remove();
                }
            });

            // 3. SECURITY: do NOT re-create/execute imported <script> elements.
            //    Auto-running script carried in imported HTML is stored XSS for
            //    every visitor of the page. Remove any that reached the DOM.
            c.querySelectorAll('script').forEach(function (oldScript) {
                oldScript.remove();
            });

            // 4. Anchor scroll — bypass Blazor navigation for #hash links
            c.querySelectorAll('a[href^="#"]').forEach(function (a) {
                a.addEventListener('click', function (e) {
                    var hash = a.getAttribute('href');
                    if (!hash || hash === '#') return;
                    var target = document.querySelector(hash) || document.getElementById(hash.substring(1));
                    if (target) {
                        e.preventDefault();
                        e.stopPropagation();
                        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        history.replaceState(null, '', hash);
                    }
                });
            });

            // 5. Fix native <select> dropdown in dark-background containers.
            c.querySelectorAll('select').forEach(function (sel) {
                var cs = window.getComputedStyle(sel);
                var rgb = (cs.color || '').match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/);
                if (!rgb) return;
                var lum = (parseInt(rgb[1],10)*299 + parseInt(rgb[2],10)*587 + parseInt(rgb[3],10)*114) / 1000;
                if (lum > 160) {
                    sel.style.colorScheme = 'dark';
                    var bg = cs.backgroundColor || '';
                    var bgM = bg.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/);
                    var optBg = (bgM && (parseInt(bgM[1],10)+parseInt(bgM[2],10)+parseInt(bgM[3],10)) < 120) ? bg : '#0a2540';
                    sel.querySelectorAll('option').forEach(function (opt) {
                        opt.style.background = optBg;
                        opt.style.color = '#fff';
                    });
                }
            });
        }
    };
}
})();
